import {createContext} from 'react'

export const LegacyChatInitialMessageContext = createContext<
  {text: string; transcriptAttachmentLabel: string; report: (turnId: string, visible: boolean) => void} | undefined
>(undefined)
